import React, { useEffect, useState } from "react";
import {
  Box, Paper, Stack, Typography, Grid, Button,
  Dialog, DialogTitle, DialogContent, IconButton, CircularProgress, Alert,
} from "@mui/material";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { getKumesKameralari, getKameraHlsUrl } from "../../services/api";
import CanliKamera from "./CanliKamera";

function KameraKarti({ kamera, onGoruntule }) {
  return (
    <Paper
      elevation={0}
      sx={{ borderRadius: 3, border: "1px solid #E5E7EB", overflow: "hidden", bgcolor: "#fff" }}
    >
      <Box
        sx={{
          height: 190,
          bgcolor: "#E9EDF2",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <VideocamOutlinedIcon sx={{ fontSize: 46, color: "#94A3B8" }} />
        <Typography sx={{ fontSize: 12.5, color: "#94A3B8", fontWeight: 600 }}>
          Canlı görüntü
        </Typography>
      </Box>

      <Box sx={{ p: 1.75 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#0F172A" }} noWrap>
            {kamera.CAM_CESIT_ADI}
          </Typography>
          <Typography sx={{ fontSize: 12.5, color: "#7C8AA5" }} noWrap>
            {kamera.KAMERA_YERLESIM_ADI}
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          startIcon={<VisibilityOutlinedIcon />}
          onClick={() => onGoruntule(kamera)}
          sx={{
            mt: 1.5,
            height: 40,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 700,
            bgcolor: "#0F172A",
            "&:hover": { bgcolor: "#1E293B" },
          }}
        >
          Görüntüle
        </Button>
      </Box>
    </Paper>
  );
}

export default function Kameralar({ kumesId }) {
  const [kameralar, setKameralar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hata, setHata] = useState("");
  const [aktif, setAktif] = useState(null);

  useEffect(() => {
    if (!kumesId) return;
    setLoading(true);
    setHata("");
    getKumesKameralari(kumesId)
      .then((res) => setKameralar(res?.data?.data ?? []))
      .catch((err) =>
        setHata(err?.response?.data?.message || "Kamera bilgileri alınamadı.")
      )
      .finally(() => setLoading(false));
  }, [kumesId]);

  return (
    <Paper
      elevation={0}
      sx={{ p: { xs: 2, md: 2.5 }, borderRadius: 4, border: "1px solid #E5E7EB", bgcolor: "#fff" }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <PhotoCameraOutlinedIcon sx={{ color: "#0F172A" }} />
        <Typography sx={{ fontSize: 17, fontWeight: 800, color: "#0F172A" }}>
          Kameralar
        </Typography>
      </Stack>

      {loading && (
        <Box sx={{ py: 5, display: "flex", justifyContent: "center" }}>
          <CircularProgress size={28} />
        </Box>
      )}

      {!loading && hata && <Alert severity="error">{hata}</Alert>}

      {!loading && !hata && kameralar.length === 0 && (
        <Alert severity="info">Bu kümese tanımlı kamera bulunamadı.</Alert>
      )}

      {!loading && kameralar.length > 0 && (
        <Grid container spacing={2}>
          {kameralar.map((k) => (
            <Grid item xs={12} sm={6} key={k.CIHAZ_CAM_ID}>
              <KameraKarti kamera={k} onGoruntule={setAktif} />
            </Grid>
          ))}
        </Grid>
      )}

<Dialog
        open={Boolean(aktif)}
        onClose={() => setAktif(null)}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { borderRadius: 4, m: { xs: 1, sm: 3 } } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography sx={{ fontSize: 17, fontWeight: 800 }}>
                {aktif?.CAM_CESIT_ADI}
              </Typography>
              <Typography sx={{ fontSize: 12.5, color: "#7C8AA5" }}>
                {aktif?.KAMERA_YERLESIM_ADI}
              </Typography>
            </Box>
            <IconButton onClick={() => setAktif(null)}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ pb: 3, px: { xs: 1.5, sm: 3 } }}>
          {aktif && <CanliKamera src={getKameraHlsUrl(aktif.CIHAZ_CAM_ID)} />}
        </DialogContent>
      </Dialog>
    </Paper>
  );
}